<template>
    <div class="Main-page">
      <div class="mainpage-firstpage">
        <P class="describe">عکس صفحه اول سایت و اسلایدر آن :</P>
        <v-card class="card"
                elevation="2"
        >

          <div class="margin">
            <MainPagePicture></MainPagePicture>
            <v-divider></v-divider>
            <list-slider :imageSlider="false" :textSlider="true" :titleSlider="true" :dateSlider="false" :linkSlider="true"></list-slider>
          </div>
        </v-card>
        <div class="features">
          <P class="describe">متن قسمت ویژگی </P>
          <features></features>
        </div>
        <div class="video">
          <p class="describe">بارگذاری ویدیو</p>
          <video-upload></video-upload>
        </div>
        <div class="banner">
          <p class="describe">بارگذاری عکس بنر بالای صفحه برای موبایل و وب :</p>
          <occational-banner></occational-banner>
        </div>
        <div class="unitAndShops">
          <p class="describe">قسمت واحد ها و فروشگاه ها اسلایدر</p>
          <main-page-units-and-shops></main-page-units-and-shops>
        </div>
        <div class="banner">
          <p class="describe">بارگذاری عکس بنر برای موبایل و وب:</p>
          <banner></banner>
        </div>
        <div class="offer">
          <p class="describe">پیشنهاد های لوتوس :</p>
          <offer></offer>
        </div>
<!--        <div class="contact">-->
<!--          <p class="describe">اطلاعات تماس با ما:</p>-->
<!--          <ContanctInfo></ContanctInfo>-->
<!--        </div>-->
      </div>

    </div>
</template>

<script>
  import formInput from '../component/formInput'
  import listShowSlider from '../component/listShowSlider'
  import Features from "../component/features";
  import banner from "../component/banner";
  import Offer from "../component/offer";
  import MainPagePicture from "../component/MainPagePicture";
  import MainPageUnitsAndShops from "../component/mainPageUnitsAndShops";
  import occationalBanner from "../component/occationalBanner";
  import videoUpload from "../component/videoUpload";
  export default {
    name: 'MainPage',
    components:{
      MainPageUnitsAndShops,
      MainPagePicture,
      // ContanctInfo,
      Offer,
      banner,
      Features,
      formInput,
      occationalBanner,
      listSlider : listShowSlider,
      videoUpload,

    },
    data:()=>({
     imageOne:'عکس پس زمینه اصلی سایت',
      mobilePath:'عکس پس زمینه موبایل '
  })
  }
</script>

<style scoped>
  .card{
    width: 85%;
    margin: 0 auto;
  }
  .describe{
    margin-right: 2rem;
    margin-bottom: 0.7rem;
    font-size: 2rem;
    font-weight: 900;
    margin-top: 2rem;
  }
  .text-title{
    font-size: 1.3rem;
    font-weight: bold;
    margin: 0;
  }
  .margin{
    width: 90%;
    margin: 0 auto;
    padding: 50px 0;
  }
  .features{
    margin-top: 2rem;
  }

</style>
